import axios from '../config/axios';

const API_BASE = '/online-payments';

export const onlinePaymentService = {
  getIntent: (intentId) => axios.get(`${API_BASE}/${intentId}`),
  cancelIntent: (intentId) => axios.post(`${API_BASE}/${intentId}/cancel`),
  confirmIntent: (intentId) => axios.post(`${API_BASE}/${intentId}/confirm`),
};

export default onlinePaymentService;
